
export  function filtersleads(leads,actufilters) {
    let affileads = [...leads] ;
    actufilters?.origines!=='allorigines' && (affileads = affileads?.filter(l=>l?.origine===actufilters?.origines)) ;
    actufilters?.campagnes!=='allcamps' && (affileads = affileads?.filter(l=>l?.campagne?.split('/')[0]?.trim()===actufilters?.campagnes) );

    return affileads.filter(l=>actufilters?.commerciaux?.includes(l?.commercial)) ; 
}

export  function filterscontrats(contrats,actufilters){
    if(!contrats){return []}
    let affcontrats= [...contrats] ;
    actufilters.compagnies!=='allcomps' && (affcontrats = affcontrats.filter(l=>l.compagnie===actufilters.compagnies) );

    return affcontrats.filter(l=>actufilters?.commerciaux?.includes(l?.commercial)) ; 
}



export  function definejsonequipes(equipes,users,equipes_managers){

    let jsonequipes ={} ;
    if(!!equipes && !!users && !!equipes_managers && !!equipes_managers){ 
        for(let eq of [...equipes]){
            let usersequipes = [...users].filter(x=>x.id_equipe === eq.id) ; 
            if(equipes_managers[eq.id]){
                const id_managers_equipe = Array.from(equipes_managers[eq.id]) ;
                users.filter(u=>id_managers_equipe?.includes(u.id))?.forEach(x=>usersequipes.push(x))  ;
                jsonequipes[eq.id] = [...usersequipes?.map(x=>x.nom)];
            }
        }
    }
    return jsonequipes

}

const dateactu = new Date().toISOString().split('T')[0];
const datedemain =  new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0];

const datedimanche =new Date(new Date().setDate(new Date().getDate() - new Date().getDay())).toISOString().split('T')[0];
const datedimanchepassee = new Date(new Date().setDate(new Date().getDate() - new Date().getDay() - 7)).toISOString().split('T')[0];

const debutmois=  new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA').split('T')[0]; 
const finmois=  new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0]; 
const debutmoisprecedent=  new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toLocaleDateString('en-CA').split('T')[0];


 

export const jsonlistedates ={today : [dateactu,datedemain],
                            lastweek : [datedimanchepassee,datedimanche],
                            thismonth : [debutmois,finmois],
                            lastmonth : [debutmoisprecedent,debutmois]}